export default "__VITE_ASSET__NNlj6d$H__"